import React, { useState } from 'react';
import './Efficiencypallet.css';

const Efficiencypallet = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    country: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    alert('Thank you! We will get back to you in 24 hours.');
    setFormData({
      name: '',
      email: '',
      company: '',
      country: '',
      phone: '',
      message: ''
    });
  };

  return (
    <div className="pallet-info-container">
      <h1>Where Quality Meets Efficiency</h1>
      <h2>Pallet Injection Molding Machines - Precision,</h2>
      <h2>Stability, Customized Solutions</h2>
      <p>
        Our superior two-platen design outperforms in delivering optimized results for various pallet sizes.
        Experience tangible improvements in your production process and efficiency through our proven solutions.
      </p>
      <button className="get-price-btn" onClick={() => setShowForm(!showForm)}>
        {showForm ? 'Hide Quote Form' : 'Get Machine Price'}
      </button>

      {showForm && (
        <>
            <div className="backdrop" onClick={() => setShowForm(false)}></div>

        <div className="quote-container">
          <h2>Request a Free Quote</h2>
          <p>Please let us know your requirements in detail, we will get back to you in 24 hours.</p>
          <form onSubmit={handleSubmit} className="quote-form">
            <div className="form-group">
              <label>Name *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Name*" />
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Email*" />
            </div>

            <div className="form-group">
              <label>Company</label>
              <input type="text" name="company" value={formData.company} onChange={handleChange} placeholder="Company" />
            </div>

            <div className="form-group">
              <label>Country *</label>
              <select name="country" value={formData.country} onChange={handleChange} required>
                <option value="">Select Country*</option>
                <option value="India">India</option>
                <option value="USA">USA</option>
                <option value="UK">UK</option>
                <option value="Germany">Germany</option>
                <option value="Canada">Canada</option>
              </select>
            </div>

            <div className="form-group">
              <label>Phone/WhatsApp</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="India +91" />
            </div>

            <div className="form-group">
              <label>Message *</label>
              <textarea name="message" value={formData.message} onChange={handleChange} required placeholder="Your Message*"></textarea>
            </div>

            <button type="submit" className="submit-btn">Send</button>
          </form>
        </div>
        </>
      )}
    </div>
  );
};

export default Efficiencypallet;
